import { Resolution } from 'src/domains/calculators/utilities/types';

/**
 * Calculate protection percentage from area ratio
 * Example: custom framing is 0.8 of canvas -> 20% protection needed
 */
function convertToPercentage(filledRatio: number): number {
  const protectionRatio = Math.max(0, 1 - filledRatio);
  const percentage = protectionRatio * 100;
  // Round to 10 decimal places to avoid floating point precision issues
  // This handles cases like 1 - 0.9 = 0.09999999999999998
  return Math.round(percentage * 1e10) / 1e10;
}

/**
 * Calculate protection percentage (only for custom framing mode)
 */
export function getProtectionPercentage(
  framingDecisionResolution: Resolution,
  protectionAreaResolution: Resolution
): number | null {
  // Calculate protection needed to reach canvas edge in the closest direction
  const widthRatio =
    framingDecisionResolution.width / protectionAreaResolution.width;
  const heightRatio =
    framingDecisionResolution.height / protectionAreaResolution.height;

  // The protection should be based on whichever dimension is closest to the canvas edge
  const maxRatio = Math.max(widthRatio, heightRatio);

  // Protection is the percentage needed to expand from custom framing to canvas edge
  // If the custom framing is larger than canvas, no protection is needed
  if (maxRatio >= 1) {
    return 0;
  }

  // Protection percentage = (1 - custom_framing / canvas) * 100
  const protection = convertToPercentage(maxRatio);

  return Math.max(0, protection);
}
